const IconVuetify = () => (
    <svg width="128" height="128" viewBox="0 0 671 670" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M335.712 653.926C511.874 653.926 654.68 511.12 654.68 334.959C654.68 158.798 511.874 15.9911 335.712 15.9911C159.551 15.9911 16.7446 158.798 16.7446 334.959C16.7446 511.12 159.551 653.926 335.712 653.926ZM335.712 660.28C515.381 660.28 661.034 514.628 661.034 334.959C661.034 155.289 515.381 9.63721 335.712 9.63721C156.042 9.63721 10.3906 155.289 10.3906 334.959C10.3906 514.628 156.042 660.28 335.712 660.28Z" fill="#AEDDFF"/>
      <path d="M487.497 69.8977C497.814 69.8977 506.178 61.534 506.178 51.2169C506.178 40.8998 497.814 32.5361 487.497 32.5361C477.18 32.5361 468.816 40.8998 468.816 51.2169C468.816 61.534 477.18 69.8977 487.497 69.8977Z" fill="#1697F6"/>
      <path d="M183.927 637.394C194.244 637.394 202.608 629.031 202.608 618.714C202.608 608.397 194.244 600.033 183.927 600.033C173.61 600.033 165.246 608.397 165.246 618.714C165.246 629.031 173.61 637.394 183.927 637.394Z" fill="#1697F6"/>
      <path d="M340.924 289.261L243.566 457.927L335.753 617.695L457.854 406.209L579.899 194.724H395.469L340.924 289.261Z" fill="#1697F6"/>
      <path d="M213.71 406.209L220.104 417.331L311.179 259.51L348.598 194.724H335.755H91.6094L213.71 406.209Z" fill="#AEDDFF"/>
      <path d="M395.469 194.724C441.618 346.595 335.753 617.695 335.753 617.695L243.566 457.927L395.469 194.724Z" fill="#1867C0"/>
      <path d="M348.598 194.724C154.16 194.724 220.103 417.331 220.103 417.331L348.598 194.724Z" fill="#7BC6FF"/>
    </svg>
    // <svg width="128" height="128" viewBox="-18.5 0 293 293" version="1.1">
    //   <g>
    //     <polyline fill="#1697F6" points="128 0 68 0 128 141.816367">
    //
    //     </polyline>
    //     <polyline fill="#1867C0" points="128 0 188 0 128 141.816367">
    //
    //     </polyline>
    //     <polyline fill="#7BC6FF" points="128 182.743732 128 292.459439 0 42.5575194 67.0490402 42.5575194">
    //
    //     </polyline>
    //     <polyline fill="#AEDDFF" points="128 182.746214 128 292.461921 256 42.5600014 188.95096 42.5600014">
    //
    //     </polyline>
    //   </g>
    // </svg>
);

export default IconVuetify;
